'use client';

import type { ReactNode } from 'react';
import { EditModeProvider } from '@locusly/client-runtime';

// Read-only content context for the published site. Editable* components read
// the live Convex values from useEditMode().values; on the public site there is
// no editing, so onChange is a no-op. Without this provider the published page
// falls back to each client's static bundled defaults instead of the content
// managed in the editor / super admin.
export function PublicContentProvider({
  values,
  children,
}: {
  values: Record<string, unknown>;
  children: ReactNode;
}) {
  return (
    <EditModeProvider editing={false} values={values} onChange={() => {}}>
      {children}
    </EditModeProvider>
  );
}
